import { Container, Box, Typography, Grid } from "@mui/material";
import HomeLayout from "../../layouts/HomeLayout";
import { useTranslation } from "react-i18next";
import Image from "next/image";

import i18n from "i18next";
import CustomSnackBar from "components/CustomSnackBar";

import { GlobalContext } from "context";

// components
import WysiwygViewer from "components/TextEditorViewer";
import { useEffect, useState, useContext } from "react";

const Content = ({}) => {
  const { state } = useContext(GlobalContext);

  const { t } = useTranslation();

  const handleCloseSnack = () => {
    setSnack({ ...snack, isOpen: false });
  };

  return (
    <Container maxWidth={false}>
      <Box className="w-full h-[100px] relative flex-shrink-0">
        {/* <Image
          src="/30.png"
          alt="Company Logo"
          fill
          className="object-cover rounded-md"
          priority
        /> */}
      </Box>

      <Container
        maxWidth="md"
        style={{
          paddingBottom: 16,
          paddingTop: 30,
          minHeight: "60vh",
        }}
      >
        <Box
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "justify",
            lineHeight: 2,
          }}
        >
          <Box className=" text-center">
            <Typography variant={"h2"}>
              Монголын Чих Хамар Хоолойн Эмч Нарын Нийгэмлэг
            </Typography>
          </Box>
          <Box
            style={{
              marginTop: 40,
              paddingRight: 50,
              paddingLeft: 50,
              paddingBottom: 50,
              borderRadius: 10,
              boxShadow: "rgba(31, 45, 61, 0.125) 0px 0px 30px",
            }}
          >
            <Box className={"mt-6"}>
              {i18n.language === "en" ? (
                <Box className="text-[16px] "></Box>
              ) : (
                <>
                  <Box className="text-[16px] ">
                    Монголын Чих Хамар Хоолойн Эмч Нарын Нийгэмлэг (цаашид
                    нийгэмлэг гэнэ) нь чих хамар хоолойн эмч нар болон
                    мэргэжилтнүүдийг сайн дурын үндсэн дээр нэгтгэсэн, Монгол
                    Улсын Үндсэн Хууль, Төрийн бус байгууллагын тухай хууль,
                    бусад хууль тогтоомжийн хүрээнд нийгэмд үйлчилдэг, өөрийгөө
                    удирдах зарчмаар үйл ажиллагаа явуулдаг ашгийн бус, төрийн
                    бус байгууллага болно Нийгэмлэг нь улсын бүртгэлд бүртгэлд
                    бүртгүүлсэн бие даасан хуулийн этгээд бөгөөд нийгэмлэгийн
                    эмблем, албан бичгийн хэвлэмэл хуудас, тамга, харилцах
                    данстай байна Нийгэмлэгийн хаяг: Улаанбаатар хотод төвлөрөн
                    үйл ажиллагаа явуулна. Цахим хаяг: mon_entsociety.mn,
                    электрон шуудан: Monentsociety2023@gmail.com Үүсгэн
                    байгуулагдсан он: 1967 он
                  </Box>

                  <Box className="text-[16px] font-semibold ">Зорилго</Box>

                  <Box className="text-[16px] ">
                    Монголын Чих Хамар Хоолойн Эмч Нарын Нийгэмлэг (цаашид
                    нийгэмлэг гэнэ) нь чих хамар хоолойн эмч нар болон
                    мэргэжилтнүүдийг сайн дурын үндсэн дээр нэгтгэсэн, Монгол
                    Улсын Үндсэн Хууль, Төрийн бус байгууллагын тухай хууль,
                    бусад хууль тогтоомжийн хүрээнд нийгэмд үйлчилдэг, өөрийгөө
                    удирдах зарчмаар үйл ажиллагаа явуулдаг ашгийн бус, төрийн
                    бус байгууллага болно Нийгэмлэг нь улсын бүртгэлд бүртгэлд
                    бүртгүүлсэн бие даасан хуулийн этгээд бөгөөд нийгэмлэгийн
                    эмблем, албан бичгийн хэвлэмэл хуудас, тамга, харилцах
                    данстай байна Нийгэмлэгийн хаяг: Улаанбаатар хотод төвлөрөн
                    үйл ажиллагаа явуулна. Цахим хаяг: mon_entsociety.mn,
                    электрон шуудан: Monentsociety2023@gmail.com Үүсгэн
                    байгуулагдсан он: 1967 он
                  </Box>
                  <Box className="text-[16px] font-semibold ">
                    Үйл ажиллагааны үндсэн чиглэл
                  </Box>

                  <Box className="text-[16px] ">
                    Чих хамар хоолой, толгой хүзүүний мэс заслын салбарт
                    ажилладаг эмч, судлаач нарын хоорондын уялдаа холбоог
                    сайжруулан тэдний мэдлэг, мэргэжлийг байнга дээшлүүлэх
                    Нийгэмлэг нь олон улсын болон дотоодын байгууллагуудтай
                    хамтран ажиллах, олон улсын хурал зөвлөгөөнд оролцох болон
                    өөрийн оронд зохион байгуулах, Чих хамар хоолойн эмч нарт
                    орчин үеийн ололт амжилт, ёс зүйн талаарх мэдээллийг түгээх,
                    мэргэжил дээшлүүлэх , дадлага, мэдлэгийг нэмэгдүүлэх
                    сургалт, семинар зохион байгуулах, ном товхимол, мэдээллийн
                    материал гаргах Эмч нарын мэргэжлийн зэрэг ахиулах,
                    дээшлүүлэх арга хэмжээг зохион байгуулахад холбогдох
                    байгууллагуудтай хамтран ажиллана. Эмч нарыг дүгнэн
                    мэргэжлийн бүтээмж, ур чадварыг үнэлэн шагнан урамшуулах
                  </Box>
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Container>
    </Container>
  );
};

Content.Layout = HomeLayout;

export default Content;
